import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from './contexts/AuthContext';
import { PrivateRoute } from './components/PrivateRoute';
import ArticleList from './components/ArticleList';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ForgotPassword } from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { AdminLayout } from './components/AdminLayout';
import { Dashboard } from './pages/admin/Dashboard';
import UploadArticle from './pages/UploadArticle';
import { ChangePassword } from './pages/ChangePassword';
import { UserMenu } from './components/UserMenu';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { Toaster } from 'react-hot-toast';
import { Profile } from './pages/Profile';
import { ScrollToTop } from './components/ScrollToTop';

console.log('App version:', import.meta.env.VITE_APP_VERSION);

function LogoutRoute() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    navigate('/login');
  }, [logout, navigate]);

  return null;
}

function AppContent() {
  const location = useLocation();
  const { user } = useAuth();
  const isAuthPage = ['/login', '/register', '/forgot-password', '/reset-password'].some(path => 
    location.pathname.startsWith(path)
  );

  useEffect(() => {
    // Se for uma página de artigo, redirecionar para o Next.js
    if (location.pathname.startsWith('/article/')) {
      window.location.replace(`http://localhost:3001${location.pathname}`);
    }
  }, [location.pathname]);

  // Se estiver redirecionando para o artigo, não renderiza nada
  if (location.pathname.startsWith('/article/')) {
    return null;
  }

  return (
    <div className={`app ${isAuthPage ? 'auth-page' : ''}`}>
      {!isAuthPage && (
        <header className="app-header">
          <div className="header-content">
            <Link to="/" className="app-title">
              <img src="/assets/images/logo.png" alt="Logo Biblioteca MD Ensino" width="65" height="65" />
              <h1>Biblioteca MD Ensino</h1>
            </Link>
            {user && <UserMenu />}
          </div>
        </header>
      )}
      <main className="app-content">
        <Routes>
          {/* Rotas públicas */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          
          {/* Rota do artigo - será redirecionada via useEffect */}
          <Route path="/article/:id" element={null} />
          
          <Route path="/logout" element={<LogoutRoute />} />

          {/* Rotas protegidas */}
          <Route path="/" element={
            <PrivateRoute>
              <ArticleList />
            </PrivateRoute>
          } />
          <Route path="/upload" element={
            <PrivateRoute>
              <UploadArticle />
            </PrivateRoute>
          } />
          <Route path="/change-password" element={
            <PrivateRoute>
              <ChangePassword />
            </PrivateRoute>
          } />

          {/* Rotas de admin */}
          <Route path="/admin" element={
            <PrivateRoute requiredRole={'ADMIN'}>
              <AdminLayout />
            </PrivateRoute>
          }>
            <Route index element={<Dashboard />} />
          </Route>

          <Route path="/profile" element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          } />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        gutter={8}
        containerStyle={{
          top: 40
        }}
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
            padding: '16px',
            borderRadius: '8px',
          },
          success: {
            iconTheme: {
              primary: '#4CAF50',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#f44336',
              secondary: '#fff',
            },
          },
        }}
      />
      <HelmetProvider>
        <Router>
          <ScrollToTop />
          <AppContent />
        </Router>
      </HelmetProvider>
    </>
  );
}

export default App;
